const ArrowLeftNew = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.3704 11.0969H5.07382V12.8852H20.3704V11.0969Z'
        fill='#E9E6E6'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.888 11.8722L10.6177 7.26449L9.31974 6L4.59004 10.6077C3.8008 11.3766 3.80737 12.6189 4.58546 13.3878L4.59003 13.3923L9.31974 18L10.6177 16.7355L5.8912 12.1309C5.81415 12.0533 5.82103 11.9375 5.888 11.8722Z'
        fill='#E9E6E6'
      />
      <path
        d='M19.1111 12.9304V11.1304H20.3704L21 12.9304H19.1111Z'
        fill='#E9E6E6'
      />
    </svg>
  );
};

export default ArrowLeftNew;
